export default "__VITE_ASSET__CC4G2ByJ__"